import { Component, Input, OnInit } from '@angular/core';
@Component({
  selector: 'app-wipperoz-have-question',
  templateUrl: './wipperoz-have-question.component.html',
  styleUrls: ['./wipperoz-have-question.component.scss']
})
export class WipperozHaveQuestionComponent implements OnInit {
  @Input() questionTitle? = $localize`:@@haveQuestionsTitle:Have any question?`;
  @Input() answerTitle? = $localize`:@@dontHesitateToContact:Don't hesitate to contact us`;
  @Input() contactLink? = $localize`:@@helpIntercomLink:https://help.wipperoz.com/en/support/home`;
  constructor() {}

  ngOnInit(): void {}
}
